"use client"

import { useEffect } from "react"
import { initMixpanel } from "@/lib/mixpanel.client"

export function MixpanelAnalyticsInit() {
  useEffect(() => {
    initMixpanel()
  }, [])

  return null
}
